import { BCMSRecord, useGlobalController, useParams, Workflow } from "@bcm-dev/bcms-vite";
import { Bill, Biller, Payment } from "model";

import EditPaymentPage from "compid/pages/EditPaymentPage";
import React from "react";

const steps = {
    "editPayment" : <EditPaymentPage />
};

/**
 * @function EditPaymentWorkflow
 * @returns {React.Component}
 * @description The main component for the edit payment workflow
 * @example
 * <EditPaymentWorkflow />
 */
export default function EditPaymentWorkflow(props) {
    // Initalize a global controller and retrieve ids from the parameters
    const controller = useGlobalController();
    const { paymentID, stepID } = useParams();
    // Initalize the default values
    const value = getDefaultEdit(controller, paymentID);
    return <Workflow value={ value } steps={ Object.values(steps) } step={ stepID } />
}

/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @description Hook to return the steps of the workflow
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefaultEdit
 * @param {bcmsController} controller - The global controller
 * @param {STRING} paymentID - The payment that should be edited
 * @returns {OBJECT}
 * @description Return the default values for the workflow
 */
export const getDefaultEdit = (controller, paymentID) => {
    BCMSRecord.globalControllerFor([ Payment, Biller, Bill ], controller);

    const payment = paymentID === undefined ? Payment.firstInstanceOf() : Payment.initByID(paymentID);
    const bill = Bill.getBillByBiller(payment.to.id);
    bill.amount = payment.amount;

    return { payment, bill, paymentAmount: payment.amount };
}